<div *ngIf="isClose === false && ((hasFeature$ | async)('VISITOR'))"
     class="notification-message-container flex flex-row justify-between items-center"
>
  <div>
    <span>Note:</span> <span>You have been assigned to this Task and you can view the basic details below, including the current Task
    Status, Title/Description and Due Date (if applicable). Please make sure to review any Attachments and Comments from the
    left-hand menu.</span>
  </div>
  <button (click)="close()" analyticsAction=""
          analyticsCategory=""
          mat-icon-button
          particleAnalytics>
    <mat-icon>close</mat-icon>
  </button>
</div>
<form [formGroup]="taskDetailForm" class="flex flex-col full-grow-no-shrink-no-basis">
  <div *ngIf="(boardList$ | async)" class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-0-0-100">
      <mat-label>Board</mat-label>
      <mat-select disabled="true" formControlName="board">
        <mat-option *ngFor="let board of (boardList$ | async)?.items" [value]="board">
          {{board.title}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div [style.display]="statusHidden ? 'none': ''" class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-0-0-100">
      <mat-label>Status</mat-label>
      <mat-select
        [disabled]="!hasPermissionForChangeStatus"
        formControlName="status">
        <mat-option *ngFor="let status of (statusList$ | async)" [value]="status.status">
          {{status.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-0-0-100">
      <mat-label>Title</mat-label>
      <input [disableControl]="!hasPermission" formControlName="title" matInput particleDisableFormControl
             placeholder="Title" required>
      <mat-error *ngIf="taskDetailFormErrors.title?.required">
        Title is required!
      </mat-error>
    </mat-form-field>
  </div>
  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-0-0-100">
      <mat-label>Description</mat-label>
      <textarea [disableControl]="!hasPermission" formControlName="description" matInput particleDisableFormControl
                placeholder="Description"
                rows="5"></textarea>
    </mat-form-field>
  </div>

  <div class="m-t-10 flex flex-row">
    <div class="task-details-date-pickers" [ngClass]="!isSubTask ? 'parent-task-datepicker' : '' ">
      <div class="wrapper flex flex-col">
        <mat-label>
          <mat-checkbox (change)="onFormValuesChanged()" [(ngModel)]="startDateEnabled"
                        [disabled]="!hasPermission || relativeStartDateEnabled"
                        [ngModelOptions]="{standalone: true}">
            Start Date
          </mat-checkbox>
        </mat-label>
        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="md-100">
            <input
              [disableControl]="!startDateEnabled || !hasPermission || relativeStartDateEnabled"
              [matDatepicker]="startDatePicker"
              formControlName="taskStartDate"
              matInput
              particleDisableFormControl>
            <mat-datepicker-toggle [disabled]="!hasPermission" [for]="startDatePicker"
                                   matSuffix></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="wrapper flex flex-col">
        <mat-label>
          <mat-checkbox (change)="onFormValuesChanged()" [(ngModel)]="dueDateEnabled"
                        [disabled]="!hasPermission || relativeDueDateEnabled"
                        [ngModelOptions]="{standalone: true}">
            Due Date
          </mat-checkbox>
        </mat-label>
        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="md-100">
            <input [disableControl]="!dueDateEnabled || !hasPermission || relativeDueDateEnabled"
                   [matDatepicker]="dueDatePicker"
                   formControlName="dueDate"
                   matInput particleDisableFormControl>
            <mat-datepicker-toggle [disabled]="!hasPermission" [for]="dueDatePicker"
                                   matSuffix></mat-datepicker-toggle>
            <mat-datepicker #dueDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="flex flex-col" *ngIf="isSubTask">
      <div formGroupName="relativeStartDate" class="m-b-15 flex flex-col justify-start items-start">
        <mat-checkbox (change)="onFormValuesChanged()"
                      [(ngModel)]="relativeStartDateEnabled"
                      [disabled]="!hasPermission"
                      [ngModelOptions]="{standalone: true}">
          Relative Start Date
        </mat-checkbox>
        <div class="m-l-10 m-r-20 flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="number m-r-10 m-b-0"
                          style="margin-bottom:0!important">
            <mat-label>Number</mat-label>
            <mat-select [disabled]="!relativeStartDateEnabled" formControlName="unit">
              <mat-option *ngFor="let number of numbers" [value]="number">
                {{number}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="period m-b-0"
                          style="margin-bottom:0!important">
            <mat-label>Period</mat-label>
            <mat-select [compareWith]="compareFunction" [disabled]="!relativeStartDateEnabled" formControlName="period">
              <mat-option *ngFor="let daysType of daysDifferenceType" [value]="daysType">
                {{daysType.displayText}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div formGroupName="relativeDueDate" class="flex flex-col justify-start items-start">
        <mat-checkbox
          (change)="onFormValuesChanged()"
          [(ngModel)]="relativeDueDateEnabled"
          [disabled]="!hasPermission"
          [ngModelOptions]="{standalone: true}">
          Relative Due Date
        </mat-checkbox>
        <div class="m-l-10 m-r-20 flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="number m-r-10 m-b-0"
                          style="margin-bottom:0!important">
            <mat-label>Number</mat-label>
            <mat-select [disabled]="!relativeDueDateEnabled" formControlName="unit">
              <mat-option *ngFor="let number of numbers" [value]="number">
                {{number}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="period m-b-0"
                          style="margin-bottom:0!important">
            <mat-label>Period</mat-label>
            <mat-select [compareWith]="compareFunction" [disabled]="!relativeDueDateEnabled" formControlName="period">
              <mat-option *ngFor="let daysType of daysDifferenceType" [value]="daysType">
                {{daysType.displayText}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

</form>

<mat-accordion class="custom-accordion box-appearance hide m-t-20">
  <div class="header flex flex-row justify-start items-center" style="cursor: pointer;">
    <span class="material-icons">keyboard_arrow_up</span>
    <span class="material-icons">keyboard_arrow_down</span>
    <strong>DAC6 & MDR Reporter Resources</strong>

  </div>


  <div style="border-top: 1px solid rgba(0,0,0,.10);">
    <div class="orbitax-services-content">
      <dl>
        <dt>Board</dt>
        <dd>General</dd>
        <dt>Status</dt>
        <dd>
          <div class="status inprogress">In Progress</div>
        </dd>
        <dt>Labels</dt>
        <dd><a href="#">Add Label</a></dd>
        <dt>People</dt>
        <dd>Oliver Long, Hasan Masud</dd>
      </dl>
    </div>
  </div>
</mat-accordion>

